import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { UpdateChannelFlowRequestFilterSensitiveLog, } from "../models/models_0";
import { de_UpdateChannelFlowCommand, se_UpdateChannelFlowCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class UpdateChannelFlowCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "UpdateChannelFlow", {})
    .n("ChimeSDKMessagingClient", "UpdateChannelFlowCommand")
    .f(UpdateChannelFlowRequestFilterSensitiveLog, void 0)
    .ser(se_UpdateChannelFlowCommand)
    .de(de_UpdateChannelFlowCommand)
    .build() {
}
